/* React hooks */
import {useEffect, useState, useCallback, useRef} from "react";
import {updateDeceasedFamilyStatus} from "../../api/pro/deceasedReq";
import useAuth from "../../hooks/useAuth";
import {useLocation, useParams} from "react-router-dom";
import FormButtons from "../../components/common/FormButtons";
import {checkRequiredFields, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormFamilyStatusInfos({
    legend,
    deceasedInfos,
    apiDeceasedInfos,
    setShowModal,
    setShowPartnerModal,
    setShowChildModal,
    setNewChild,
    setShowConfirmChildModal,
    setChildCreatedCount,
    registerSubmitFunction,
    onMaritalStatusChange,
    noSubmitButton = false
}) {
    const { auth } = useAuth();
    const token = auth?.token;
    const { id } = useParams();
    const [values, setValues] = useState();
    const { pathname } = useLocation();
    const fieldsetRef = useRef();
    const isInitialized = useRef(false);

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value })
        if (onMaritalStatusChange && e.target.name === "maritalStatus") {
            onMaritalStatusChange(e.target.value);
        }
        validateFormInput(e)
    };

    useEffect(() => {
        // N'initialiser QU'UNE SEULE FOIS : un rechargement de deceasedInfos suite à l'enregistrement
        // réussi d'un autre sous-formulaire ne doit pas écraser une sélection en cours non sauvegardée.
        if (isInitialized.current || !deceasedInfos) {
            return;
        }
        setValues({
            ...values,
            maritalStatus : deceasedInfos?.maritalStatus,
        })
        if (onMaritalStatusChange) {
            onMaritalStatusChange(deceasedInfos?.maritalStatus);
        }
        isInitialized.current = true;
    }, [ deceasedInfos ]);

   const maritalOptions = {
        1 : "Marié(e)" ,
        2 : "Veuf(ve)" ,
        3 : "Divorcé(e)" ,
        4 : "Célibataire" ,
        5 : "Pacsé(e)" ,
        6 : "Union libre",
        7 : "Séparé(e)" ,
    }

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault()

        // Utiliser fieldsetRef pour la validation
        if (!checkRequiredFields(fieldsetRef.current)) {
            return;
        }
        const body = {
            deceasedId : id,
            maritalStatus : values?.maritalStatus,
        }
        await updateDeceasedFamilyStatus(token, body)

        if (!noSubmitButton) {
            apiDeceasedInfos()
            setShowModal(false)

            if (pathname?.includes("infos-complementaires/creer")) {
                const maritalStatusRequiringPartner = ["1", "5", "6", "7", 1, 5, 6, 7]; // Marié, Pacsé, Union libre, Séparé
                const maritalStatusNoPartner = ["2", "3", "4", 2, 3, 4]; // Veuf, Divorcé, Célibataire

                if (maritalStatusRequiringPartner.includes(values?.maritalStatus)) {
                    if (setShowPartnerModal) {
                        setTimeout(() => {
                            setShowPartnerModal(true);
                        }, 300);
                    }
                } else if (maritalStatusNoPartner.includes(values?.maritalStatus)) {
                    if (setShowConfirmChildModal && setChildCreatedCount) {
                        setTimeout(() => {
                            setChildCreatedCount(0);
                            setShowConfirmChildModal(true);
                        }, 300);
                    } else if (setShowChildModal && setNewChild) {
                        setTimeout(() => {
                            setNewChild(1);
                            setShowChildModal(true);
                        }, 300);
                    }
                }
            }
        }
    }, [values, token, id, noSubmitButton, apiDeceasedInfos, pathname, setShowModal, setShowPartnerModal, setShowConfirmChildModal, setChildCreatedCount, setShowChildModal, setNewChild]);
    
    useEffect(() => {
        if (registerSubmitFunction) {
            registerSubmitFunction(handleSubmit);
        }
    }, [registerSubmitFunction, handleSubmit]);

    const handleRemoveModal = () => {
        if (setShowModal) {
            setShowModal(false);
        }
    }

    const content = (
        <fieldset ref={fieldsetRef}>
            <legend>{legend || "Statut marital"}</legend>
            <div className="form-input">
                <label className="required" htmlFor="maritalStatus">Statut marital</label>
                <select required name="maritalStatus" value={values?.maritalStatus || ""} onChange={onChange}>
                    <option disabled value="">Choisir</option>
                    { maritalOptions &&
                        Object.entries(maritalOptions).map(([key, value]) => (
                            <option key={key} value={key}>{value}</option>
                        ))
                    }
                </select>
            </div>
            <div className="errors"></div>

            {/* Boutons pour la création */}
            {!noSubmitButton && <FormButtons handleRemoveModal={handleRemoveModal}/>}
        </fieldset>
    );

    // Si noSubmitButton est false (mode modal), wrapper dans un form
    // Si noSubmitButton est true (mode inline), pas de wrapper form (sera dans le form parent)
    return noSubmitButton ? content : (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            {content}
        </form>
    );
}